interface ToggleSwitchProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  activeColor?: string;
  inactiveColor?: string;
  labelPosition?: "left" | "right";
  disable?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  label,
  activeColor = "#2C92FF",
  inactiveColor = "#000000",
  labelPosition = "right",
  disable = false,
}) => {
  const handleToggle = () => {
    if (!disable) {
      onChange(!checked);
    }
  };

  return (
    <div
      className={`flex items-center gap-2 pb-2.5 ${
        labelPosition === "left" ? "flex-row-reverse" : ""
      }`}
    >
      <label
        className={`flex items-center ${
          disable ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        }`}
      >
        <div className="relative">
          <input
            type="checkbox"
            className="sr-only"
            checked={checked}
            onChange={handleToggle}
            disabled={disable}
          />
          <div
            className="w-10 h-6 rounded-full transition-colors"
            style={{
              backgroundColor: checked ? activeColor : "#ffffff",
              border: checked ? "none" : `1px solid ${inactiveColor}`,
              opacity: disable ? 0.6 : 1,
            }}
          ></div>
          <div
            className="absolute left-1 top-1 w-4 h-4 rounded-full transition-transform"
            style={{
              backgroundColor: checked ? "#ffffff" : inactiveColor,
              transform: checked ? "translateX(16px)" : "translateX(0px)",
              opacity: disable ? 0.6 : 1,
            }}
          ></div>
        </div>
      </label>
      {label && (
        <span
          className={`text-sm gx-font-medium text-gray-700 ${
            disable ? "opacity-50" : ""
          }`}
        >
          {label}
        </span>
      )}
    </div>
  );
};

export default ToggleSwitch;
